<template>
	<div class="bg-light p-2 mb-2">
		<div>
			<span>
				<slot>{{ label }}</slot>
			</span>
			x
			{{ quantity }}
		</div>
		<span class="text-secondary" v-html="displayCost" />
	</div>
</template>

<script setup>
    import { computed } from 'vue'

    const props = defineProps({
        label: String,

        cost: {
            type     : Number,
            required : true
        },

        quantity: {
            type     : Number,
            required : true
        }
    })

    const totalCost = computed(() => props.cost * props.quantity)

    const displayCost = computed(() => {
        if (!totalCost.value || totalCost.value === 0){
            return 'Free'
        }

        return "&pound;" + parseFloat(totalCost.value).toFixed(2)
    })
</script>
